// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-a5631","checkmark":"checkmark-a5631","text":"text-a5631","checked":"checked-a5631","disabled":"disabled-a5631","shine":"shine-a5631"};